import React, { Component } from 'react';

// 都道府県コンポーネント読み込み
import Hokkaido from './Hokkaido'
import Tohoku from './Tohoku'
import Kanto from './Kanto'
import Chubu from './Chubu'
import Kinki from './Kinki'
import Chugoku from './Chugoku'
import Shikoku from './Shikoku'
import Kyusyu from './Kyusyu'


class Prefectures extends Component {

  render() {
    let visitedData = {
      '岡山': {num_visit: 12, num_all: 12},
      '鳥取': {num_visit: 0, num_all: 12},
      '広島': {num_visit: 0, num_all: 12},
      '島根': {num_visit: 0, num_all: 12},
      '山口': {num_visit: 0, num_all: 12},
    }
    return (
      <div className="Prefectures">
        <Kyusyu />
        <div>
          <Chugoku visitedData={visitedData} />
          <Shikoku />
        </div>
        <Kinki />
        <Chubu />
        <Kanto />
        <Tohoku />
        <Hokkaido />
      </div>
    );
  }

}

export default Prefectures;
